import { NotificationForm } from '../../../../../../notificationForms/sections/notifications/components/NotificationForm'
import { NotificationView } from '../../../../../../notificationForms/sections/notifications/components/NotificationView'

import { AlmostThereNotificationView } from './components/AlmostThereNotificationView'

import { useFormStateController } from '../../hooks/useFormStateController'
import { useLiveEtaStatus } from '../../hooks/useLiveEtaStatus'
import { useAlmostThereNotificationSubmit } from './hooks/useAlmostThereNotificationSubmit'
import { useAlmostThereNotificationToggle } from './hooks/useAlmostThereNotificationToggle'
import { useAlmostThereNotificationValues } from './hooks/useAlmostThereNotificationValues'

import type { FormProps } from '../types'
import { useTexts } from './useTexts'

/**
 * Renders the AlmostThere notification form providing all the domain data and apis.
 */
export function AlmostThereNotification(props: FormProps) {
  const { inEditing, setEditingState } = props

  const values = useAlmostThereNotificationValues()

  const { toggleDescription, onToggle } = useAlmostThereNotificationToggle(values)
  const { edit, cancel } = useFormStateController(setEditingState)
  const onSubmit = useAlmostThereNotificationSubmit()
  const liveEtaStatus = useLiveEtaStatus()
  const texts = useTexts()

  const available = liveEtaStatus !== 'notActive' && liveEtaStatus !== 'notAvailableForTheUser'

  // Render the Form inside a FormRoot component that will expose the FormState API through a React.Context
  if (inEditing) {
    return (
      <NotificationForm
        subtitle={texts.description}
        notification="almostThere"
        onSubmit={onSubmit}
        title={texts.title}
        cancel={cancel}
        values={values}
      />
    )
  }

  return (
    <NotificationView
      Form={<AlmostThereNotificationView values={values} />}
      toggleSubtitle={toggleDescription}
      subtitle={texts.description}
      notification="almostThere"
      available={available}
      onToggle={onToggle}
      title={texts.title}
      values={values}
      onEdit={edit}
    />
  )
}
